import { EventAggregator } from "aurelia-event-aggregator";
import { autoinject } from "aurelia-framework";
import { get } from "jquery";
import { Models } from "models/core";
import { DeleteDialogService } from "services/delete-dialog-service";
import { ErrorService } from "services/error-service";
import { LocationCodeService } from "services/location-code-service";
import { ToastService } from "services/toast-service";

@autoinject
export class ServiceStationLocationCodes {

  private serviceStationId: number;
  private locationCodes: Array<Models.LocationCode>;

  private locationCodeNewFormVisible;
  private locationCodeEditFormVisible;
  private locationCode: Models.LocationCode;

  private nextTabIndex: number = null;

  constructor(
    private locationCodeService: LocationCodeService,
    private toastService: ToastService,
    private errorService: ErrorService,
    private eventAggregator: EventAggregator,
    private deleteDialogService: DeleteDialogService,
  ) {
  
  }

  activate(params) {
    this.serviceStationId = params.Id;

    this.getLocationCodes(this.serviceStationId);

    // Get new tabIndex for tabs component via EA, store value so we can publish this if canDeactivate returns true
    this.eventAggregator.subscribe('changeTab', (tabIndex) => {
      this.nextTabIndex = tabIndex;
    });
  }

  private canDeactivate() {
    // TODO add proper guards
    this.eventAggregator.publish('changeTab-success', this.nextTabIndex);    
  }

  getLocationCodes(serviceStationId: number) {
    this.locationCodeService.getAll(`?$filter=ServiceStationId eq ${serviceStationId}`)
      .then(res => {
        this.locationCodes = res;        
      })
      .catch(err => this.errorService.handleError(err));
  }

  addLocationCode() {
    this.locationCodeNewFormVisible = true;
    this.locationCodeEditFormVisible = false;

    this.locationCode = new Models.LocationCode();
    this.locationCode.ServiceStationId = this.serviceStationId;
  }

  createLocationCode() {
    this.locationCodeService.post(this.locationCode)
      .then(res => {
        this.toastService.showSuccess("locationCode.created");
        this.getLocationCodes(this.serviceStationId);
        this.locationCodeNewFormVisible = false;
      })
      .catch(err => this.errorService.handleError(err));
  }

  updateLocationCode(locationCode: Models.LocationCode) {
    this.locationCodeService.put(locationCode, locationCode.Id)
      .then(res => {
        this.toastService.showSuccess("locationCode.updated");
        this.getLocationCodes(this.serviceStationId);
        this.locationCodeEditFormVisible = null;
      })
      .catch(err => this.errorService.handleError(err));
  }

  deleteLocationCode(locationCodeId: number) {
    this.deleteDialogService.confirmBeforeDelete(() => {
      this.locationCodeService.delete(locationCodeId)
        .then(res => {
          this.toastService.showSuccess("locationCode.deleted");
          this.getLocationCodes(this.serviceStationId);
        })
        .catch(err => this.errorService.handleError(err));
    });
  }
}